<template lang="html">
	<div draggable='true' @dragstart="handleDragStart($event, vt)">
		<li class="group bg-gray-900 slide-in-item col-span-1 h-24 rounded-lg shadow overflow-hidden relative videoTake">
			<img :src="vt.thumbnail_url" class="absolute inset-0 z-1 object-cover w-full h-full transform"  :class="getRotationAngle(vt.rotation)"> 
			<div class="w-full h-full flex align-bottom p-2 absolute inset-0 z-0 bg-black opacity-40 group-hover:opacity-0"></div>
			<div class="w-full h-full flex align-bottom p-2 absolute inset-0 z-1 cursor-pointer"  @click="loadClipPlayback(vt);">
				<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 absolute top-2 left-2 hidden" v-if="vt.is_previous || vt.is_current || vt.is_next">
				{{ vt.is_previous ? 'Previous' : '' }}
				{{ vt.is_current ? 'Current' : '' }}
				{{ vt.is_next ? 'Next' : '' }}
				</span>
				<span class="hidden inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 absolute top-2 right-2" v-if="index == 0">
					New
				</span>
				<span data-tippy-content="This take was taken in with the viewport rotated. Support to display these takes correctly is coming soon." class="text-red-500 absolute top-2 left-2 hidden" v-if="vt.rotation != 0">
					<!-- Heroicon name: solid/exclamation-sign -->
					<svg class="w-5 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.25706 3.09882C9.02167 1.73952 10.9788 1.73952 11.7434 3.09882L17.3237 13.0194C18.0736 14.3526 17.1102 15.9999 15.5805 15.9999H4.4199C2.89025 15.9999 1.92682 14.3526 2.67675 13.0194L8.25706 3.09882ZM11.0001 13C11.0001 13.5523 10.5524 14 10.0001 14C9.44784 14 9.00012 13.5523 9.00012 13C9.00012 12.4477 9.44784 12 10.0001 12C10.5524 12 11.0001 12.4477 11.0001 13ZM10.0001 5C9.44784 5 9.00012 5.44772 9.00012 6V9C9.00012 9.55228 9.44784 10 10.0001 10C10.5524 10 11.0001 9.55228 11.0001 9V6C11.0001 5.44772 10.5524 5 10.0001 5Z" clip-rule="evenodd"/></svg>
				</span>
				<div class="flex-1 truncate absolute bottom-2 left-2 takeName">
					<div class="flex items-center space-x-3 w">
					<h3 class="text-white text-sm font-medium text-shadow truncate">{{vt.name}}</h3>
					</div>
				</div>
				<div class="flex-1 truncate absolute top-2 right-2" v-show="!isSharedVideos">
					<div class="flex items-center space-x-3">
					<button class="text-white hover:text-gray-300" v-on:click.stop="canFavorite && toggleFavorite()" v-show="vt.is_favorite">
					<!-- Star filled icon -->
					<svg class="fill-current h-5 w-5 shadow-lg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 1.3l2.388 6.722H18.8l-5.232 3.948 1.871 6.928L10 14.744l-5.438 4.154 1.87-6.928-5.233-3.948h6.412L10 1.3z"/></svg>
					</button>
					<button class="text-transparent not-favorite" v-on:click.stop="canFavorite && toggleFavorite()" v-show="!vt.is_favorite">
					<!-- Star outline icon -->
					<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.8 8.022h-6.413L10 1.3 7.611 8.022H1.199l5.232 3.947-1.871 6.929L10 14.744l5.438 4.154-1.869-6.929L18.8 8.022zM10 12.783l-3.014 2.5 1.243-3.562-2.851-2.3 3.522.101 1.1-4.04 1.099 4.04 3.521-.101-2.851 2.3 1.243 3.562-3.012-2.5z"/></svg>
					</button>
					</div>
				</div>
				<div class="flex-1 truncate absolute bottom-2 right-2 takeDuration">
					<div class="flex items-center space-x-3 w">
					<h3 class="text-white text-sm font-medium text-shadow">{{vt.duration_in_seconds}}s</h3>
					</div>
				</div>
			</div>
		</li>
	</div>
</template>
<script>
import { getRotationAngle } from 'utils/rotate-viewport'

export default {
	props: ["vt", "index", "isSharedVideos", "canFavorite"],
	methods: {
		getRotationAngle(rotation){
			return getRotationAngle(rotation);
		},
		toggleFavorite(){
			this.$emit("toggleFavorite")
    },
	 loadClipPlayback(){
		this.$emit("loadClipPlayback")
	 },
	 // Drag and Drop
    handleDragStart(event){
		 const take = this.vt;
        event.dataTransfer.dropEffect = 'move'
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('type', 'VIDEO_TAKE')
        event.dataTransfer.setData('take', JSON.stringify(take))

        // create custom draggable image
        const elem = document.getElementById("ghostFrame");
        elem.src = take.thumbnail_url;
        const rect = elem.getBoundingClientRect()
        event.dataTransfer.setDragImage(elem, rect.width/2, rect.height/2);
    },

	},
	
}
</script>
<style lang="scss" scoped>
.videoTake{
  // .takeName, 
  .takeDuration{
    transition: opacity 0.1s ease-in;
    opacity: 0;
  }

  // &:hover .takeName,
  &:hover .takeDuration
  {
    opacity: 1;
  }
  &:hover .not-favorite
  {
    color: white;
  }

}
</style>
